module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Killwangen-6b4d2f82a6ea223762eabf7ca0eeaee1.svg";